// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2HLHd","addWidgetButton":"Header_addWidgetButton__36oCi","dashboardTabs":"Header_dashboardTabs__3hISm","active":"Header_active__2tUjS"};